/**
 * Component metadata — icon and description for each component type
 */

export const componentMeta: Record<string, { icon: string; description: string }> = {
  header: { icon: '\u{1F4CC}', description: 'Navigation und Logo' },
  hero: { icon: '\u{1F3AF}', description: 'Hauptbereich mit Headline' },
  trust: { icon: '\u2728', description: 'Zahlen und Fakten' },
  authority: { icon: '\u{1F3C5}', description: 'Credentials / Vertrauen' },
  services: { icon: '\u{1F527}', description: 'Leistungen als Karten' },
  proofTable: { icon: '\u{1F4CA}', description: 'Vergleich / Differenzierung' },
  process: { icon: '\u{1F9ED}', description: 'Ablauf in Schritten' },
  benefits: { icon: '\u2705', description: 'Vorteile mit Checkmarks' },
  team: { icon: '\u{1F465}', description: 'Team-Mitglieder' },
  gallery: { icon: '\u{1F5BC}\uFE0F', description: 'Bildergalerie' },
  testimonials: { icon: '\u{1F4AC}', description: 'Kundenstimmen' },
  faq: { icon: '\u2753', description: 'H\u00e4ufige Fragen' },
  cta: { icon: '\u{1F4DE}', description: 'Kontakt-Aufruf' },
  stickyCta: { icon: '\u{1F9F2}', description: 'Fixer CTA-Balken' },
  footer: { icon: '\u{1F4CB}', description: 'Fusszeile' },
  cookie: { icon: '\u{1F36A}', description: 'Cookie-Hinweis' },
};
